'use strict';

var log = require('../../log/Log').channel('CallFieldsExtension');

var CallFieldsExtension = function() {
    log.info('initializing');

    var vm = this;

    vm.callfields = {};
    vm.callfields.getContactName = getContactName;
    vm.callfields.getDialString = getDialString;
    vm.callfields.getMeetingCodes = getMeetingCodes;
    vm.callfields.getContactPicture = getContactPicture;
    vm.callfields.getContactPictureStyle = getContactPictureStyle;
    vm.callfields.hasContactPicture = hasContactPicture;

    function getContactName(call) {
        if (angular.isDefined(call)) {
            if (angular.isDefined(call.contactName) &&
                call.contactName !== '') {
                return call.contactName;
            } 
            else if (angular.isDefined(call.displayDialString) &&
                     call.displayDialString !== '') {
                return call.displayDialString.split(',')[0];
            }
            else if (angular.isDefined(call.dialString)) {
                return call.dialString;
            }
        }

        return '';
    }

    function getDialString(call) {
        if (angular.isDefined(call)) {
            if (angular.isDefined(call.displayDialString) &&
                call.displayDialString !== '' &&
                angular.isDefined(call.contactName) &&
                call.contactName !== '') {
                return call.displayDialString.split(',')[0];
            }
            else if (angular.isDefined(call.dialString) &&
                call.dialString !== '' &&
                angular.isDefined(call.contactName) &&
                call.contactName !== '') {
                return call.dialString;
            } else if (angular.isDefined(call.contactName)) {
                return call.contactName;
            }
        }

        return '';
    }

    function getMeetingCodes(call) {
        if (angular.isDefined(call) &&
            call.hasOwnProperty('meetingCodes')) {
            var meetingCodes = '';
            var keys = Object.keys(call.meetingCodes).sort();
            for (var i = 0; i < keys.length; i++) {
                meetingCodes += call.meetingCodes[keys[i]];
                if (i < keys.length - 1) {
                    meetingCodes += ', ';
                }
            }
            return meetingCodes;
        }

        return '';
    }

    function getContactPicture(call) {
        if (angular.isDefined(call) &&
            angular.isDefined(call.$contactPicture)) {
            return call.$contactPicture;
        }
        return '';
    }

    function getContactPictureStyle(call) {
        var url = getContactPicture(call);
        var attr = 'url(\'' + url + '\')';
        return { 
            'background-image': attr
        };
    }

    function hasContactPicture(call) {
        if (angular.isDefined(call)) {
            if (angular.isDefined(call.$contactPicture) &&
                call.$contactPicture !== '') {
                return true;
            }
        }
        return false;
    }
};

module.exports = CallFieldsExtension;
